import httpbaseURL from '../../../../modules/Inventory/common/axios';
class AssetStatusServices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetStatusMaster/Create", doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetStatusMaster/Update", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetStatusMaster/AssetSatusList")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetStatusMaster/Get?id=" + doc)
    }

    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/AssetStatusMaster/Delete?id=" + doc)
    }

    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "/AssetStatusMaster/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new AssetStatusServices()